import AllOrdersPage from './AllOrdersPage'

export default AllOrdersPage